const safePath = path => /^\/(?!\/)[a-zA-Z0-9/_.-]*$/.test(path) && !path.includes("..");
const safeParameter = key => /^[a-zA-Z][a-zA-Z0-9_]*(?:\[[a-zA-Z][a-zA-Z0-9_]*\]){0,2}$/.test(key);
const answerKey = parameter => parameter.replace(/\[|\]/g, "_").replace(/_+/g, "_").replace(/^_|_$/g, "").toLowerCase().slice(0, 40);
const readable = parameter => parameter.replace(/\[|\]/g, " ").replace(/_/g, " ").replace(/\s+/g, " ").trim();

export function importListingUrl(input, currentBase) {
  const raw = input.trim();
  if (!raw || /\s/.test(raw)) throw new Error("Paste one GET listing URL, without surrounding text.");
  let base = currentBase.trim().replace(/\/$/, "");
  let url;
  if (raw.startsWith("/")) {
    if (!base) throw new Error("Enter the API base URL first when pasting a relative path.");
    url = new URL(raw, new URL(base));
  } else {
    url = new URL(raw);
    if (!base) base = url.origin;
  }
  const baseUrl = new URL(base);
  if (url.protocol !== "https:" || baseUrl.protocol !== "https:" || url.origin !== baseUrl.origin || url.username || url.password || url.hash || baseUrl.username || baseUrl.password || baseUrl.search || baseUrl.hash) {
    throw new Error("Use a public HTTPS listing URL on the configured API domain, without credentials.");
  }
  const prefix = baseUrl.pathname.replace(/\/$/, "");
  if (prefix && !url.pathname.startsWith(`${prefix}/`)) throw new Error("The listing URL must be under the API base URL.");
  const path = url.pathname.slice(prefix.length);
  if (!safePath(path)) throw new Error("The listing path contains unsupported characters.");
  const warnings = [];
  const fields = [];
  let limitKey = "";
  let paginate = false;
  for (const [parameter, sample] of url.searchParams) {
    if (!safeParameter(parameter)) { warnings.push(`${parameter} was skipped because the API parameter name is unsupported.`); continue; }
    if (parameter === "paginate" && sample === "1") { paginate = true; continue; }
    if (["size", "limit", "per_page"].includes(parameter) && /^\d+$/.test(sample)) { limitKey = parameter; if (sample !== "8") warnings.push(`${parameter} will use 8 results per request.`); continue; }
    if (/^filter\[/.test(parameter)) {
      if (fields.some(field => field.parameter === parameter)) continue;
      const key = answerKey(parameter);
      if (!/^[a-z][a-z0-9_]{0,39}$/.test(key) || fields.some(field => field.key === key)) { warnings.push(`${parameter} needs a unique answer key; add it manually.`); continue; }
      const numeric = /^\d+(?:\.\d+)?$/.test(sample);
      fields.push({ key, prompt: `What is your ${readable(parameter)}?`, kind: numeric ? "number" : "text", parameter, required: true, choices: [], lookupPath: "", lookupQueryKey: "type", lookupQueryValue: "", lookupResultsPath: "", lookupIdField: "id", lookupLabelField: "name" });
      warnings.push(`Review ${parameter}: the sample value ${JSON.stringify(sample)} does not identify its answer type, choices, or ID lookup.`);
    } else warnings.push(`${parameter} is a fixed request value. The catalog does not save fixed query parameters yet.`);
  }
  if (fields.length > 8) throw new Error("This URL has more than eight filters. Import fewer filters and add another request if needed.");
  const name = path.split("/").filter(Boolean).at(-1)?.replace(/[-_]/g, " ") || "Partner results";
  return {
    base,
    warnings,
    operation: {
      id: `api-${crypto.randomUUID()}`,
      label: `Search ${name}`,
      path,
      method: "GET",
      inputKey: "q",
      limitKey,
      paginate,
      responseMode: "list",
      resultsPath: "items",
      idField: "id",
      titleField: "title",
      descriptionField: "description",
      urlField: "url",
      attributesField: "attributes",
      inputFields: fields,
    },
  };
}
